import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { MutationConfig } from 'lib/react-query';

/** X accepts video and image only; the backend rejects html for X. */
export type ReuploadCreativeType = 'image' | 'video';

export interface ReuploadCreativeRef {
  /** Primary key of the source row (the digit part of `video:7`), not the ADAM creative_id field. */
  id: number;
  creative_type: ReuploadCreativeType;
}

/** `{ app: 'MB', creatives: [{ id: 7, creative_type: 'image' }] }` */
export interface ReuploadCreativesParams {
  app: string;
  creatives: ReuploadCreativeRef[];
}

export interface ReuploadCreativesResponse {
  job_id: string;
}

/** The job finishes with the same `job_status` result rows as Facebook create-ad. */
export const reuploadCreatives = async (data: ReuploadCreativesParams): Promise<ReuploadCreativesResponse> => {
  const res = await apiClient.post<ReuploadCreativesResponse>('/api/v1/twitter_manager/upload_to_twitter', data);
  return res.data;
};

export const useReuploadCreatives = ({ config }: { config?: MutationConfig<typeof reuploadCreatives> } = {}) =>
  useMutation({ ...config, mutationFn: reuploadCreatives });
